'use strict';

var chroma = require("chroma-js"),
    uuid = require("uuid");

var {grammar} = require("../../../language.js");

var toExport = {
  initSemantics
};

if(typeof module !== "undefined" && typeof module.exports !== "undefined"){
  module.exports = toExport;
} else {
  Object.assign(window, toExport);
}


function initSemantics(that, superSemantics){
  let svgBounds = that.svg[0][0].getBoundingClientRect();
  let semantics = superSemantics?
      grammar.extendSemantics(superSemantics):
      grammar.semantics();

  semantics.addAttribute('dom', {
    _default(children){
      return that.exampleView.ohmToDom.get(this._node);
    }
  });

  semantics.addAttribute('bounds', {
    _default(children){
      return this.dom.getBoundingClientRect();
    }
  });

  //adds attributes containing contextual info to nodes
  let augmentNode = function(node){
    let depth = node.args.depth || 0;
    let maxDepth = Math.max(depth, node.args.maxDepth || -1);
    let parent = node.args.parent || null;
    let siblings = node.args.siblings || [];

    Object.assign(node, {depth, parent, siblings, uuid: uuid.v1()});

    return maxDepth;
  }
  semantics.addOperation('augment(depth, maxDepth, parent, siblings)', {
    _default(children){ //nonterminal and iter
      let maxDepth = augmentNode(this);
      let depth = this.args.depth || 0;

      return children.reduce((agg, child)=>
        Math.max(agg, child.augment(depth+1, maxDepth, this, children)), -1);
    },
    _terminal(){
      return augmentNode(this);
    }
  });

  //separates nodes out into nodes to be drawn vertically or not
  let vhBucketsNode = function(node){
    let drawVertical = node.args.drawVertical;
    let {vertical, horizontal} = node.args;

    Object.assign(node, {drawVertical});
    (drawVertical? vertical: horizontal).push(node);

    if(drawVertical){
      node.overlappingSiblings = node.siblings.reduce((agg, sibling)=> agg || overlappingY(sibling, node), false);
      if(!node.interval.contents.includes('\n')){ //one liner
        horizontal.push(node);
      }
    }
  };
  semantics.addOperation('vhBuckets(vertical, horizontal, drawVertical)', {
    _nonterminal(children){
      vhBucketsNode(this);
      let {vertical, horizontal, drawVertical} = this.args;

      if(this.isSyntactic()){
        if(doesNotConsume(this)){
          children.forEach((child)=> child.vhBuckets(vertical, horizontal, drawVertical));
        } else if(this.interval.contents.includes('\n')){//this.bounds.height >= that.lineHeight * 1.5){
          children.forEach((child)=> child.vhBuckets(vertical, horizontal, true));
        } else {
          children.forEach((child)=> child.vhBuckets(vertical, horizontal, false));
        }
      }
    },
    _iter(children){
      vhBucketsNode(this);
      let {vertical, horizontal, drawVertical} = this.args;

      if(doesNotConsume(this)){
        children.forEach((child)=> child.vhBuckets(vertical, horizontal, drawVertical));
      } else if(this.interval.contents.includes('\n')){//this.bounds.height >= that.lineHeight * 2){
        children.forEach((child)=> child.vhBuckets(vertical, horizontal, true));
      } else {
        children.forEach((child)=> child.vhBuckets(vertical, horizontal, false));
      }
    },
    _terminal(){
      vhBucketsNode(this);
    }
  })

  let {top: parentTop, left: parentLeft} = svgBounds;
  semantics.addAttribute('verticalPath', {
    _default(children){
        let x = this.depth*that.parameters.annotationWidth + that.parameters.annotationWidth;
        return [
          [x, this.bounds.top - parentTop],
          [x, this.bounds.bottom - parentTop]
        ];
    }
  });

  semantics.addAttribute('horizontalPath', {
    _default(children){
      return [
        [this.bounds.left+1 - parentLeft, this.bounds.bottom+that.parameters.annotationWidth*this.relativeDepth - parentTop],
        [this.bounds.right-1 - parentLeft, this.bounds.bottom+that.parameters.annotationWidth*this.relativeDepth - parentTop]
      ];
    }
  });

  let horizpath = function(node){
    let {line, relativeDepth} = node.args;
    let leftmost = line.nodes
                     .reduce((agg, b)=> agg.bounds.left < b.bounds.left? agg: b)
                     .bounds.left;
    let rightmost = line.nodes
                      .reduce((agg, b)=> agg.bounds.right > b.bounds.right? agg: b)
                      .bounds.right;
    let y = line.nodes[0].bounds.bottom+ that.parameters.annotationWidth*relativeDepth - parentTop;

    if(node.bounds.top === line.start){
      return [
        [node.dom.offsetLeft+1 /* +node.bounds.left - parentLeft*/, y],
        [rightmost - parentLeft, y]
      ];
    } else if(node.bounds.top < line.start && line.start < node.bounds.bottom
              && Math.abs((node.bounds.bottom-that.parameters.lineHeight) - line.start) > 5){
      return [
        [leftmost - parentLeft, y],
        [rightmost - parentLeft, y]
      ];
    } else if(Math.abs((node.bounds.bottom-that.parameters.lineHeight) - line.start) <= 5) { //TODO: tune this
      console.log('endLine', node.interval.contents);
      let nextSibling = line.nodes.find(n=> n.interval.startIdx === node.interval.endIdx);
      if(!nextSibling){
        nextSibling = line.verticalNodes.find((extra)=> extra.node.interval.startIdx === node.interval.endIdx);
        nextSibling = nextSibling? nextSibling.node: nextSibling;
      }
      let rightOffset = nextSibling? nextSibling.dom.offsetLeft: node.bounds.right-parentLeft;

      return [
        [leftmost - parentLeft, y],
        [rightOffset-1 /*- parentLeft*/, y]
      ];
    } else {
      throw `tried to get horizontal path for line node (${node.ctorName}) doesn't cover.
      ${node.interval.contents}
      nodeRange: [${node.bounds.top}, ${node.bounds.bottom}], lineStart: ${line.start}, lineHeight: ${that.parameters.lineHeight}
      `;
    }
  }
  semantics.addOperation('horizontalPathForLine(line, relativeDepth)', {
    _nonterminal(children){
      return horizpath(this);
    },
    _iter(children){
      return horizpath(this);
    }
  })

  return semantics;
}



function doesNotConsume(node){
  return node.children.length === 1
         && node.children[0].interval.contents === node.interval.contents;
}

function overlappingY(sibling, node){
  return sibling !== node
          && overlappingIntervals([sibling.bounds.top, sibling.bounds.bottom],
                                  [node.bounds.top   , node.bounds.bottom]);
}

function overlappingIntervals([aStart, aEnd], [bStart, bEnd]){
  return ((aStart  >= bStart && aStart <= bEnd)
       || (bStart  >= aStart && bStart <= aEnd));
}

//TODO: resume here. either pass in svg as an argument or make these part of the class proper



/** WEBPACK FOOTER **
 ** ./src/components/exampleRepresentation/visualizationOverlay/semantics.js
 **/